import React from 'react';
import { MotifTooltip, MotifInlineMessage } from '@ey-xd/motif-react';

export default (props) => {
  const { column, isEditModeActive, data } = props;

  const errorMessage = data?.[`${column.colId}_error`] || '';

  // The error condition should only apply to the selected columns when edit mode is active.
  const showError =
    ['propertyAmenityName', 'serviceNameOtherDescription', 'trsName'].includes(
      column.colId
    ) &&
    isEditModeActive &&
    errorMessage !== '';

  // Check for duplicate or max length error
  const isTooltipError =
    errorMessage.startsWith('Duplicate service name') ||
    errorMessage.startsWith('Maximum');

  return (
    <div tabIndex="-1">
      {showError ? (
        isTooltipError ? (
          <span tabIndex="-1" className="error-text">
            <MotifTooltip
              placement="top"
              trigger={
                <MotifInlineMessage variant="error" className="mt-3">
                  {data[column.colId]}
                </MotifInlineMessage>
              }
            >
              {errorMessage}
            </MotifTooltip>
          </span>
        ) : (
          <span tabIndex="-1" className="error-text">
            Required
          </span>
        )
      ) : (
        <span tabIndex="-1">{data[column.colId]}</span>
      )}
    </div>
  );
};
